import _classCallCheck from "/codebuild/output/src2989845404/src/tpp-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src2989845404/src/tpp-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * DevExtreme (esm/core/memorized_callbacks.js)
 * Version: 21.2.5
 * Build date: Mon Jan 17 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import { each } from "../core/utils/iterator";
import Callbacks from "./utils/callbacks";

var MemorizedCallbacks = /*#__PURE__*/function () {
  function MemorizedCallbacks() {
    _classCallCheck(this, MemorizedCallbacks);

    this.memory = [];
    this.callbacks = Callbacks();
  }

  _createClass(MemorizedCallbacks, [{
    key: "add",
    value: function add(fn) {
      each(this.memory, function (_, item) {
        return fn.apply(fn, item);
      });
      this.callbacks.add(fn);
    }
  }, {
    key: "remove",
    value: function remove(fn) {
      this.callbacks.remove(fn);
    }
  }, {
    key: "fire",
    value: function fire() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      this.memory.push(args);
      this.callbacks.fire.apply(this.callbacks, args);
    }
  }]);

  return MemorizedCallbacks;
}();

export { MemorizedCallbacks as default };